var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nonprofit-register-step-three"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"has-text-weight-bold nonprofit-register__heading"},[_vm._v("Add A New Nonprofit")]),_c('nonprofit-register-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }